export const changeEnterpriseDisplayNameReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_ENTERPRISE_DISPLAY_NAME":
      return action.payload.enterpriseDisplayName;
    default:
      return state;
  }
};
